import React, {useEffect, useState} from 'react'
import emailValidator from 'email-validator'

export default function CustomChip(props) {
  const [valid, setValid] = useState(false)
  useEffect(() => {
    setValid(emailValidator.validate(props.children))
  }, props.children)

  let containerStyle = styles.container
  if (props.selected) {
    containerStyle = {...containerStyle, ...styles.selected}
  }
  if (!valid) {
    containerStyle = {...containerStyle, ...styles.invalid}
  }

  return (
    <div style={containerStyle}>
      <div style={styles.text}>{props.children}</div>
      <div style={styles.remove} onClick={() => props.onRemove(props.index)}>
        &times;
      </div>
    </div>
  )
}

let styles = {
  selected: {
    background: '#ccc',
  },
  invalid: {
    borderStyle: 'solid',
    borderColor: '#F85214',
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    height: 32,
    boxSizing: 'border-box',
    color: '#444',
    background: '#e0e0e0',
    margin: '2.5px',
    borderRadius: 16,
    cursor: 'default',
  },
  text: {
    fontSize: 13,
    boxSizing: 'border-box',
    padding: '0px 4px 0px 8px',
  },
  remove: {
    textAlign: 'center',
    cursor: 'pointer',
    fontSize: 18,
    width: 20,
    height: 20,
    color: '#e0e0e0',
    borderRadius: 12,
    background: '#aaa',
    margin: '0 6px',
  },
}
